import { render, staticRenderFns } from "./CiteAction.vue?vue&type=template&id=566a62f8&scoped=true&"
import script from "./CiteAction.vue?vue&type=script&lang=js&"
export * from "./CiteAction.vue?vue&type=script&lang=js&"
import style0 from "./CiteAction.vue?vue&type=style&index=0&id=566a62f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a62f8",
  null
  
)

export default component.exports